import { languagesList } from '~utils/languageInURL/constants';
export var checkIfIsLanguageInURL = function (url) {
    if (url[0] !== '/' && url[3] !== '/') {
        return false;
    }
    var possiblyLanguage = url.slice(1, 3);
    return languagesList.includes(possiblyLanguage);
};
